import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, TransitionGroup as _TransitionGroup, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "app-notification-container container" }

import { appNotifications } from '@/services/notification.app'
import AppNotification from '@/app/components/AppNotification.vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'AppNotificationContainer',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_TransitionGroup, { name: "app-notification-container__transition" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(appNotifications).notifications, (notification) => {
          return (_openBlock(), _createBlock(AppNotification, {
            key: notification.id,
            variant: notification.variant,
            actions: notification.actions,
            onClose: ($event: any) => (_unref(appNotifications).dismiss(notification.id))
          }, {
            title: _withCtx(() => [
              _createTextVNode(_toDisplayString(notification.title), 1)
            ]),
            message: _withCtx(() => [
              _createTextVNode(_toDisplayString(notification.message), 1)
            ]),
            _: 2
          }, 1032, ["variant", "actions", "onClose"]))
        }), 128))
      ]),
      _: 1
    })
  ]))
}
}

})